import {
  signIn,
  signUp,
  confirmSignUp,
  resetPassword,
  type SignInInput,
  type SignUpInput,
  type ConfirmSignUpInput,
  type ResetPasswordInput,
} from "aws-amplify/auth";

// Amplify `Authenticator` `services` overrides — case-insensitive login.
//
// The Cognito User Pool is case-SENSITIVE: `signInCaseSensitive` is unset on
// the pool (see classactionpro/infra/cdk/lib/stacks/auth-stack.ts) and that
// property is IMMUTABLE — it cannot be flipped without replacing the pool.
// Every Cognito username is created lowercase (the invite flow lowercases
// before AdminCreateUser), so we lowercase + trim the username on the way IN
// to sign-in / sign-up / confirm / password-reset. Without this, a user who
// types `Francis@x.com` fails to match the stored `francis@x.com`.
//
// `handleSignIn` is the actual login bug fix; the rest keep sign-up and
// password reset consistent so they cannot recreate the mismatch.

const normalizeUsername = (username: string): string =>
  username.trim().toLowerCase();

export const authServices = {
  async handleSignIn(input: SignInInput) {
    return signIn({ ...input, username: normalizeUsername(input.username) });
  },
  async handleSignUp(input: SignUpInput) {
    return signUp({ ...input, username: normalizeUsername(input.username) });
  },
  async handleConfirmSignUp(input: ConfirmSignUpInput) {
    return confirmSignUp({
      ...input,
      username: normalizeUsername(input.username),
    });
  },
  async handleForgotPassword(input: ResetPasswordInput) {
    return resetPassword({
      ...input,
      username: normalizeUsername(input.username),
    });
  },
};
